
import React, { useEffect } from 'react'
import S from '../pages/ListDam.module.css'
import { useGlobalContext } from './Context'
import apiService from '../api/ApiService'
import { addTohistories } from '../redux/slices/adminSlice'
import { useDispatch, useSelector } from 'react-redux'
import { ArrowDownward } from '@mui/icons-material'

const MoveDetailStatus = ({data1,flag,SData,seenFlag}) => {
  const {data}=useSelector(state=>state.p.admin)
  const dispatch=useDispatch()

    const {closeModalls,isOpenModal,isOpenModal2,closeModalls2}=useGlobalContext();
    const toggleCycleHistory=async()=>{
      if(!SData?.isReaded){
        const res=await apiService.readCycleHistory(SData?.id)
        const filter=data.filter(item=>{
          
          return item.id!==SData.id
      })
      dispatch(addTohistories(filter))
      }
  }
  const toggleStatusHistory=async()=>{
      if(!SData?.isReaded){
        const res=await apiService.readStatusHistory(SData?.id)
        const filter=data.filter(item=>{
          
          return item.id!==SData.id
      })
      dispatch(addTohistories(filter))
    }
  }
  useEffect(()=>{
      if(flag==='cycle'&&seenFlag){
          toggleCycleHistory();
      }
      if(flag==='status'&&seenFlag){
          toggleStatusHistory()
          console.log("spp")

      }
  },[])

  return (
    <div onClick={seenFlag?closeModalls:closeModalls2} className={`modal-overlay ${(seenFlag?isOpenModal:isOpenModal2)&&'show-modal'} `}>
        <div className="editModalDamCon2 Ani AllFFFF">
        <div className={S.AnimContentLI} data-aos='fade'>
      <table>
      
        <tr>
    <th style={{fontSize:"20px"}}>جزئیات</th>
  </tr>
  {data1?.children?.map(item=><tr>
    <td>{item.name} </td>

  </tr>
)}
<tr style={{display:"flex",alignItems:"center",justifyContent:"center",padding:"5px"}}>
    <ArrowDownward/>
    <ArrowDownward/>
    <ArrowDownward/>
    <ArrowDownward/>
    <ArrowDownward/>

  </tr><tr>
    <td>{SData?.newCattleStatusTitle} </td>

  </tr>
      </table>
    </div>
    </div>


    </div>
    
  )
}

export default MoveDetailStatus
